{
  "styleGuide": {
    "title": "Style Guide",
    "subtitle": "Lorem ipsum"
  },
  "guaranteeOrderList": {
    "title": "Order list"
  },
  "guaranteeOrder": {
    "title": "Order"
  },
  "error": {
    "pageNotFound": {
      "title": "404 - Page not found at the given address"
    }
  },
  "loggedOut": {
    "title": "Logged out",
    "line1": "You have been logged out of the system.",
    "line2": "Redirecting to the PB24 portal..."
  }
}
